<template>
  <section class="container section pt-0">
    <case-datatable />
  </section>
</template>

<script>
import CaseDatatable from "./case_datatable/Index.vue";

export default {
  name: "SIRCCreditInformationIndex",
  components: { CaseDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {},
    create() {},
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
